import { createRoot } from 'react-dom/client'
import { CssVarsProvider } from '@mui/joy'
import { theme } from '../theme'
import axios from 'axios'

import '../i18n'
import SearchView from '../components/search-view'
import { API_KEY, API_VERSION } from '../constants'

axios.defaults.headers.common['x-api-key'] = API_KEY
axios.defaults.headers.common['x-api-version'] = API_VERSION

function StandaloneSearch() {
    return (
        <CssVarsProvider theme={theme}>
            <SearchView home={true} />
        </CssVarsProvider>
    )
}
  
const domNode = document.getElementById('react-home-search')

if (!domNode) throw new Error('Missing #react-home-search root')

const root = createRoot(domNode)

root.render(<StandaloneSearch />)
